module.exports = __webpack_public_path__ + "static/media/logo_ukmo.13b0feaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_ukmo.png
// module id = 242
// module chunks = 0